import { Button as ButtonCore } from '@material-ui/core';
import * as lib from '~/dependencies';
import { colors } from '~/layout';

type ButtonContainerProps = {
  isAdmin: boolean;
};

export const Container = lib.styled.div`
  overflow: auto;
  height: 100%;
  background-color: #FFF;
  margin-bottom: 12px;
  outline: none;
  padding: 0 10px 0 10px;
  overflow: -moz-scrollbars-none !important;
  -ms-overflow-style: none !important;
  display: flex;
  flex-direction: column;

  &::-webkit-scrollbar { width: 0 !important; display: none !important;  }
`;

export const Empty = lib.styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  text-align: center;

  svg {
    width: 100%;
    height: auto;
    max-width: 170px;
  }

  .title {
    font-size: 20px;
    font-weight: bold;
    color: ${colors.darkGray13};
  }

  .subTitle {
    font-size: 14px;
    text-align: center;
    color: ${colors.darkGray13};
  }

`;

export const FiltersContainer = lib.styled.div`
  display: flex;
  flex-direction: column;
`;

export const Searcher = lib.styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin: 10px;

  .btn-bulk-action {
    background: transparent;
    border: none;
    align-self: flex-end;
    cursor: pointer;

    div > div {
      display: flex;
      justify-content: center;
    }
  }
`;

export const ButtonsContainer = lib.styled.div<ButtonContainerProps>`
  display: flex;
  flex-direction: row;
  justify-content: ${(props: ButtonContainerProps) =>
    props.isAdmin ? 'space-evenly' : 'flex-start'};
  margin: 5px 10px 0px 10px;
  gap: 7px;
  overflow-x: hidden;
  white-space: wrap;
  height: 50px;

  .MuiButton-root {
    font-size: 10px;
    text-transform: none;
  }
`;

export const Button = lib.styled(ButtonCore)`
  &.MuiButton-outlined {
    border-color: ${({ isSelected }: { isSelected: boolean }) =>
      isSelected ? colors.lightGray10 : colors.lightGray17}
    border-radius: 8px;
    font-size: 11px;
    color: ${colors.darkGray11};
  }
  white-space: nowrap;
  height: 32px;
  transition: all 0.2s ease-in-out;
  ${({ isSelected }: { isSelected: boolean }) =>
    isSelected && `background-color: ${colors.lightGray10} !important; `}
`;

export const Section = lib.styled.div`
  /*
   * Use padding (not margin) for the bottom gap: the header is position:sticky,
   * and its white background only paints the padding box — a bottom *margin*
   * would leave a transparent band where the scrolling rows show through and
   * appear to overlap the header.
   */
  padding: 0px 0
    ${(props: { scrollClearfix: boolean }) =>
      props.scrollClearfix ? '30px' : '10px'}
    0; 
  background: ${colors.white};
  font-size: 14px;
  font-weight: bold;
  color: ${colors.darkGray11};
`;

export const TextField = lib.styled.input`
  outline: none;
  border: 1px solid ${colors.lightGray17};
  border-radius: 7px;
  height: 32px;
  text-align: center;
  width: 100%;
  font-size: 14px;
  letter-spacing: 0.5px;
  color: ${colors.darkGray11};

  &::placeholder {
    text-align: center;
    font-style: italic;
    font-family: Nunito;
    font-size: 14px;
    letter-spacing: 0.5px;
  }
`;

export const SearchBar = lib.styled.div`
  display: flex; 
  flex-direction: row;
  width: 100%; 
  align-items: center;

  .icon {
    margin-left: -25px;
    width: 18px;
    height: 18px;
    cursor: pointer;
    color: ${colors.darkGray11};
  }
`;

export const FooterLoader = lib.styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px 0 5px 0;
`;

export const AllConversationsSelector = lib.styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  margin-left: 10px;
  margin-bottom: 5px;

  span {
    font-size: 14px;
  }
`;

export const AllMessagesLoaded = lib.styled.div`
  font-size: 16px; 
  font-style: italic;
  opacity: 0.5;
`;
